import { render, staticRenderFns } from "./FulfillmentPackagesTab.vue?vue&type=template&id=ed2e2cfe"
import script from "./FulfillmentPackagesTab.vue?vue&type=script&lang=js"
export * from "./FulfillmentPackagesTab.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentPackagesTab.vue?vue&type=style&index=0&id=ed2e2cfe&prod&lang=scss"
import style1 from "./FulfillmentPackagesTab.vue?vue&type=style&index=1&id=ed2e2cfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports